export const getDatabaseMembers = state => state.people.databaseMembers;
export const getShowNewCallListModal = state => state.people.startNewCallList;
